import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { IOdbBillAggregatorResponse } from 'src/app/my-bill/models/aggregator.model';
import { EntityManager } from '@dch/entity-manager';
import { of } from 'rxjs';
import { map, catchError, withLatestFrom, switchMap } from 'rxjs/operators';
import { BILLING_AGGREGATOR_ENTITY } from 'src/app/my-bill/config/my-bill-entity.config';
import {
  getBillingAggregatorFailure,
  getBillingAggregatorRequest,
  getBillingAggregatorSuccess,
} from '../actions/billing-aggregator.actions';
import { ApplicationState } from '../reducers';
import { selectCustomer } from '../selectors/customer-account.selector';

@Injectable()
export class BillingAggregatorEffects {
  getBillingAggregator$ = createEffect(() =>
    this.actions$.pipe(
      ofType(getBillingAggregatorRequest),
      withLatestFrom(this.store.select(selectCustomer)),
      switchMap(([action, customer]) =>
        EntityManager.getEntity<IOdbBillAggregatorResponse>(
          BILLING_AGGREGATOR_ENTITY,
          {
            cdbId: customer.customerId,
          }
        ).pipe(
          map((entity) =>
            entity.value
              ? getBillingAggregatorSuccess({
                  billAggregatorResponse: entity.value,
                })
              : getBillingAggregatorFailure()
          ),
          catchError((error) => of(getBillingAggregatorFailure()))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store<ApplicationState>
  ) {}
}
